module.exports = __webpack_public_path__ + "c778734193e74e816bd354dc0665b8f1.svg";